const TEXT = {
    HEADING: "Endre overføringstid",
    BANKID: {
        LOGIN: {
            INGRESS:
                "For å kunne endre tid for overføring må vi vite at du har tilknytning til mobilabonnement(er). Dette gjør du ved å logge inn med BankID.",
        },
    },
    UPDATED: {
        HEADING: "Ditt overføringstidspunkt er nå endret",
    },
    ORDER_EXPIRED: {
        TEXT: "Denne forespørselen er ikke lenger aktiv. Årsaken til dette kan være at forespørselen allerede har blitt besvart, eller at tiden for å besvare har utløpt. Mistenker du at det har skjedd en feil? Ta kontakt med <a class='link' href='https://www.telia.no/kundeservice/' target='_blank'>kundeservice</a> så hjelper vi deg.",
    },
    ORDER_NOT_FOUND: {
        TEXT: "Beklager vi fant ikke angitt ordre. Årsaken til dette kan være at du ikke fikk med hele lenken inn til din nettleser. Det beste er å klikke på selve lenken du fikk i sms.",
    },
    ORDER_DEFAULT_ERROR: {
        TEXT: "Beklager en feil oppstod, vennligst prøv igjen. [upd-0]",
    },
};

export default TEXT;
